import { createGlobalStyle } from 'styled-components';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { FONT_FAMILY } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    ${FONT_FAMILY.FontRegular}
  }
  
  input:-webkit-autofill {
    -webkit-box-shadow: rgba(255,255,255,0.75);
    color: rgba(255,255,255,0.75)
  }

  a {
    text-decoration: none;
  }

  button {
    cursor: pointer;
    border: none;
    background: none;
  }

  input,button {
    border: none;
    outline: none;
  }

  a { 
    text-decoration: none;
  }

  html,body,#root {
    height: 100%;
  }

  body {
    margin: 0;
    ${FONT_FAMILY.FontRegular}
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display:flex;
    justify-content:center;
  }
  
  #root {
    width:100%;
  }

  code {
    ${FONT_FAMILY.FontRegular}
  }
  .example::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .example {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
  .redMessage{
    color: ${COLORS.red};
  }
`;

export default GlobalStyle;
